import store from './player-store';

const closeButton = $('.j-modal-close');
const container = $('.modal-share');
const startSlidePicker = $('.j-share-start-picker');
const embedStartSlidePicker = $('.j-embed-start-picker');
const sizePicker = $('#new-player .j-embed-size-picker');
const selectedSize = $('.j-embed-size-picker :selected');
const shareLinkContainers = $('.modal-share .j-share-social-list li');
const shareLinkUrl = $('#new-player #share-link-url');
const shareEmbedLink = $('#new-player #share-embed-link');
const shareEmbedWP = $('#new-player #share-embed-wp');
const shareEmbedOptions = $('.share-embed-options');

const SHARE_URLS = {
  facebook: 'https://www.facebook.com/sharer/sharer.php?',
  linkedin: 'https://www.linkedin.com/cws/share?trk=SLIDESHARE&',
  twitter: 'https://twitter.com/share?',
  wordpress: '',
};

const bindEvents = () => {
  $('.new-player-share-modal-trigger').on('click', function () {
    handleShareToggleOpen();
  });

  closeButton.on('click', function () {
    container.hide();
    store.share.isOpen = false;
  });

  startSlidePicker.on('change', function (e) {
    const slideIndex = e.target.value.match(/\d+/)[0] - 1;
    updateStartSlide(slideIndex);
  });

  embedStartSlidePicker.on('change', function (e) {
    const slideIndex = e.target.value.match(/\d+/)[0] - 1;
    updateEmbedStartSlide(slideIndex);
  });

  sizePicker.on('change', function () {
    updateEmbed();
  });

  shareLinkContainers.on('click', function (evt) {
    openSharePopup($(this).data('network'));
    evt.preventDefault();
  });

  shareEmbedLink.on('click', function () {
    this.select();
  });

  shareEmbedWP.on('click', function () {
    this.select();
  });

  shareLinkUrl.on('click', function () {
    this.select();
  });

  shareEmbedLink.on('focus', function () {
    triggerExpandEmbed();
  });
};

const triggerExpandEmbed = () => {
  shareEmbedLink.addClass('j-triggered');
  shareEmbedOptions.show();
};

const getViralQueryParam = (type) => {
  const element = $('li.' + type + ' a');
  const data = element.data();
  data.url = getNewSlideURL(store.slideshow.ss_url, 1);
  return $.param(data);
};

const getViralShareUrl = (type) => {
  var queryParam = getViralQueryParam(type);
  return SHARE_URLS[type] + queryParam;
};

const postToFacebook = () => {
  if (!window.FB) {
    return;
  }

  const successCallback = function (resp) {
    if (resp && resp.post_id) {
      saveShare('facebook');
    }
  };

  window.FB.ui(
    {
      method: 'feed',
      display: 'popup',
      link: store.slideshow.ss_url,
    },
    successCallback
  );
};

const saveShare = (network) => {
  $.get('/account/get_form_authenticity_token').done(function (resp) {
    $.post('/share/viralshare', {
      data: {
        id: store.slideshow.id,
        network: network,
      },
      authenticity_token: resp.auth_token,
    });
  });
};

const openSharePopup = (type) => {
  // Default width and height of popup
  var width = 626;
  var height = 436;

  const shareURL = getViralShareUrl(type);

  // Following a viral share, we save it to the viral share database. For
  // networks other than facebook, we do not track *completed* shares, and
  // so for them we need to call saveShare to save the viral share in the
  // viral share DB as soon as we get the initial click. For facebook, we
  // insert a row into the viral share db on successful completion of the
  // share, so we do not do it here.
  if (type === 'facebook') {
    // Facebook has a success callback
    if (window.FB) {
      postToFacebook();
      return;
    }
  } else if (type === 'linkedin') {
    if (window.IN && window.IN.UI) {
      window.IN.UI.Share().params({ url: store.slideshow.url }).place();
      saveShare(type);
      return;
    }
  }

  window.open(shareURL, 'shareDialog', 'width=' + width + ',height=' + height);
  saveShare(type);
};

const getNewSlideURL = (oldUrl, startSlide) => {
  const parser = document.createElement('a');
  parser.href = oldUrl;
  const arr = parser.pathname.split('/');
  if (!arr[0]) {
    // Shift off leading slash (in Chrome and FF -- IE has no leading slash)
    arr.shift();
  }
  var len = arr.length;
  var last = arr[len - 1];
  while (!last && len > 0) {
    // Pop off trailing slashes
    arr.pop();
    len--;
    last = arr[len - 1];
  }
  // Remove the last element if it is a number, checking that it is at least
  // the 3rd element, so as not to overwrite stripped-titles that begin with
  // numbers ('arr' => ['<user.login>', '<ss.stripped_title>', '<page>'])
  if (parseInt(last, 10) && len > 2) {
    arr.pop();
  }
  // Push new slide number onto end, unless it's the default (1)
  startSlide > 1 && arr.push(startSlide);
  parser.pathname = arr.join('/');
  return parser.href;
};

const updateEmbed = (startSlidePicker) => {
  let newLink = shareEmbedLink.val();
  const selectedSizeBlock = sizePicker.val();
  const width =
    selectedSize.data('width') ||
    store.share.embed_sizes.presets[selectedSizeBlock].size.width;
  const height =
    selectedSize.data('height') ||
    store.share.embed_sizes.presets[selectedSizeBlock].size.height;
  let url = newLink.match(/src="([^"]+)"/)[1].split('?')[0]; // TODO: check for undefined values
  const startSlide = startSlidePicker ? startSlidePicker.prop('selectedIndex') + 1 || 1 : 1;
  url += startSlide > 1 ? '?startSlide=' + startSlide : '';
  newLink = newLink.replace(/src="[^"]+"/, 'src="' + url + '"');
  newLink = newLink.replace('http:', '');
  newLink = newLink.replace('https:', '');
  newLink = newLink.replace(/height="\d+"/, 'height="' + height + '"');
  newLink = newLink.replace(/width="\d+"/, 'width="' + width + '"');
  shareEmbedLink.val(newLink);
};

const updateStartSlide = (index) => {
  startSlidePicker.prop('selectedIndex', index);
  updateEmbed(startSlidePicker);
};

const updateEmbedStartSlide = (index) => {
  embedStartSlidePicker.prop('selectedIndex', index);
  updateEmbed(embedStartSlidePicker);
};

export const hideShareScreen = () => {
  container.hide();
  store.share.isOpen = false;
};

export const handleShareToggleOpen = () => {
  if (store.share.isOpen) {
    hideShareScreen();
  } else {
    container.show();
    store.share.isOpen = true;
    populateForm();
    populateEmbedSizes();
    populateStartSlides();
    populateEmbedStartSlides();
  }
};

const populateEmbedSizes = () => {
  var embedSizesPicker = $('.j-embed-size-picker');
  $.each(store.share.embed_sizes.presets, function (key, value) {
    var displayWidth = value.size.width + 4;
    var displayHeight = value.size.height + 2;

    var option = $('<option/>')
      .val(key)
      .text(displayWidth + 'x' + displayHeight);
    embedSizesPicker.append(option);
  });
  embedSizesPicker.val(store.share.embed_sizes.config.defaultPreset).change();
};

const populateStartSlides = () => {
  var html = '';
  for (var i = 0; i < store.totalSlides; i++) {
    var fullSlides = 'slide ' + (i + 1);
    html += '<option ';
    if (i === 0) {
      html += ' selected="selected"';
    }
    html += '>' + fullSlides + '</option>';
  }

  startSlidePicker.empty();
  startSlidePicker.append(html);
  updateStartSlide(0);
};

const populateEmbedStartSlides = () => {
  var html = '';
  for (var i = 0; i < store.totalSlides; i++) {
    var fullSlides = 'slide ' + (i + 1);
    html += '<option ';
    if (i === 0) {
      html += ' selected="selected"';
    }
    html += '>' + fullSlides + '</option>';
  }

  embedStartSlidePicker.empty();
  embedStartSlidePicker.append(html);
  updateEmbedStartSlide(0);
};

const populateForm = () => {
  shareEmbedLink.val(store.share.embed_code);
  shareEmbedWP.val(store.share.wp_code);
  shareLinkUrl.val(store.share.url);
};

const addToStore = (config) => {
  store.share = {
    isOpen: false,
    embed_sizes: config.embed_sizes,
    embed_code: config.embed_code,
    wp_code: config.wp_code,
    url: getNewSlideURL(store.slideshow.ss_url, 1)
  };
};

export const initializeSharing = (config) => {
  addToStore(config);
  bindEvents();
};
